import styled from 'styled-components';
import { Typography } from '@web-chat-core/ui-kit';

export const InfoCardWrapper = styled.div`
    position: relative;
    z-index: 1;
`;

export const InfoCardContent = styled(Typography)`
    position: absolute;
    left: -12px;
    padding: 16px;
    border-radius: 12px;
    background-color: ${props => props.theme.root.colors.system.infoDefault};
`;
